import { z } from 'zod';

/**
 * Admin console wire types. The admin surface is gated server-side to the
 * configured admin emails; these shapes back the user-management page.
 */

/** A user as the admin console sees them. */
export const AdminUser = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  displayName: z.string().nullable(),
  isAdmin: z.boolean(),
  /** Non-null when the user is currently blocked. */
  blockedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
});
export type AdminUser = z.infer<typeof AdminUser>;
